"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateVariantKeyBySelectedProductVariantOptions = void 0;
const attributesIgnoredForVariants_1 = require("../attributesIgnoredForVariants");
const generateVariantKeyBySelectedProductVariantOptions = (productOptionValues = {}) => {
    const variantOptions = Object.keys(productOptionValues).sort((a, b) => (a < b ? -1 : 1));
    let variantKey = variantOptions.reduce((accum, variantOption) => {
        if (!productOptionValues[variantOption])
            return accum;
        if (attributesIgnoredForVariants_1.attributesIgnoredForVariants.includes(variantOption))
            return accum;
        return accum + productOptionValues[variantOption] + '/';
    }, '');
    if (variantKey.length) {
        variantKey = variantKey.slice(0, -1);
    }
    return variantKey;
};
exports.generateVariantKeyBySelectedProductVariantOptions = generateVariantKeyBySelectedProductVariantOptions;
//# sourceMappingURL=generateVariantKeyBySelectedProductVariantOptions.js.map